import { Input, Stack, Text, Button, Link, Flex, useToast } from "@chakra-ui/react";
import { Link as ReactLink, useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import { POST } from "../../utils/ApiRequestProvider";
import { TokenService } from "../../utils/TokenService";
import { useDispatch, useSelector } from "react-redux";
import { loadState } from "../../reducers/usersReducer";
import Cookies from 'js-cookie';
import Navbar from '../../components/Headers/LoginNavbar';

export default function Login() {
    const toast = useToast();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
        const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const user = useSelector((state: any) => state.user.value);

    useEffect(() => {
        if (user?.role) navigate("/");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    function loadUser(data: any) {
        // Always persist to localStorage — cookies have size limits and may be
        // blocked, which leaves the app unauthenticated after reload.
        try { localStorage.setItem("user", JSON.stringify(data)); } catch {}
        try { Cookies.set("user", JSON.stringify(data)); } catch {}
        dispatch(loadState(data));
    }

    async function handleSignUpClick() {
        try {
            if (password === "" || username === "") return toast({
                status: "error",
                title: "Please fill in all the fields",
                duration: 8000,
                isClosable: true,
                position: "top-right"
            });

            setIsLoading(true);
            const res = await POST(
                '/api/user/login',
                {
                    email: username,
                    password
                }
            );

            toast({
                status: res.status,
                title: res.message,
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });

            if (res.status === 'success') {
                loadUser({
                    ...res.data.user,
                    accessToken: res.data.access_token,
                    refreshToken: res.data.refreshToken
                    // role: "dataentry"
                });

                TokenService.setAccessToken(res.data.access_token.token)
                TokenService.setRefreshToken(res.data.refreshToken.token)
                navigate("/");
            }
            setIsLoading(false);
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }
    // document.addEventListener('DOMContentLoaded', () => {
    const buttonElement = document.getElementById('Btnlogin');

    // Add event listener to the document body (or a specific element)
    document.body.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Enter') {
            if(buttonElement === undefined || buttonElement === null){
                return;
            }
            buttonElement.click();
            event.preventDefault();
        }
    });
    // });
    return (
    <>
    <Navbar/>
        <Stack
            w={'full'}
            h={"100vh"}
            justify={'center'}
            align={"center"}
            py={{ base: 32, md: 64 }}
        >
            <Text mb={2} letterSpacing={5} fontSize='35px' color='textColor.headingColor'>
                Sign in
            </Text>
            <Stack as="form" spacing={3} w={'md'} p={6} onSubmit={(e) => { e.preventDefault(); handleSignUpClick(); }}>
                <Input
                    placeholder="Email"
                    type={"email"}
                    name="email"
                    autoComplete="username"
                    size={"lg"}
                    p={3}
                    fontSize={"14px"}
                    fontWeight={"400"}
                    w={"full"}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
                <Input
                    placeholder="Password"
                    type={"password"}
                    name="password"
                    autoComplete="current-password"
                    size={"lg"}
                    p={3}
                    fontSize={"14px"}
                    fontWeight={"400"}
                    w={"full"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <Button
                    bgGradient="linear(to-r, primary.100, primary.600)"
                    id="Btnlogin"
                    type="submit"
                    color="white"
                    rounded={"full"}
                    fontWeight={"400"}
                    fontSize={`sm`}
                    _hover={{ bgGradient: "linear(to-r, primary.100, primary.200)" }}
                    _active={{ bg: "linear(to-r, primary.500, primary.800)" }}
                    size={'md'}
                    w={"full"}
                    isLoading={isLoading}
                >
                    Login
                </Button>

                <Flex w={'full'} justify={'end'} direction={'column'}>
                    {/* <Checkbox
                        defaultChecked={false}
                        value={rememberMe}
                        onChange={() => SetRememberMe(rememberMe === 1 ? 0 : 1)}
                        colorScheme={"primary"}
                    >
                        Remember me
                    </Checkbox> */}
                    <Link textAlign={'center'} color={'primary.400'} as={ReactLink} to={'/forgetpassword'}>
                        Forgot Your Password?
                    </Link>
                    <Text textAlign={'center'} mb={2} fontSize={'md'} color='textColor.supportingText' fontWeight={'normal'}>
                        New Here?
                    </Text>
                    <Link textAlign={'center'} color={'primary'} fontWeight={'bold'} as={ReactLink} to={'/register'}>
                            Sign Up
                    </Link>
                </Flex>

            </Stack>
        </Stack>
    </>
    )
}